import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';
import { TextField } from '@mui/material';
import { getURLError, getErrorJSON, getSessionId, submitJSONError } from './store';

export const FallbackComponent = () => {
  const dispatch = useDispatch();
  const url = useSelector(getURLError);
  const errorJSON = useSelector(getErrorJSON);
  const sessionId = useSelector(getSessionId);
  const [additionalComment, setAdditionalComment] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [feedbackSubmitted, setFeedbackSubmitted] = useState<boolean>(false);
  return (
    <>
      <h1 style={{ margin: '20px 20px', width: '80%' }}>
        Sorry for the inconvenience. If you would like us to contact you when the error is fixed, please provide your
        email address.
      </h1>
      {!feedbackSubmitted && (
        <>
          <TextField
            label="Email"
            sx={{ margin: '20px 20px', width: '80%' }}
            value={emailAddress}
            onChange={(e) => {
              setEmailAddress(e.target.value);
            }}
          />
          <TextField
            label="Additional Comment"
            sx={{ margin: '20px 20px', width: '80%' }}
            multiline
            fullWidth
            minRows="6"
            maxRows="9"
            value={additionalComment}
            onChange={(e) => {
              setAdditionalComment(e.target.value);
            }}
          />
          <Button
            variant="outlined"
            color="primary"
            style={{ margin: '20px 20px', width: '80%' }}
            onClick={() => {
              const res = { ...JSON.parse(errorJSON), email: emailAddress, comment: additionalComment };
              dispatch(submitJSONError({ sessionId, errorJson: res }));
              setFeedbackSubmitted(true);
            }}
          >
            Submit
          </Button>
        </>
      )}
      {feedbackSubmitted && (
        <>
          <h3 style={{ margin: '40px 20px', width: '80%' }}>Thank you! Will reach out to you as soon as possible.</h3>
        </>
      )}
      <Button
        variant="outlined"
        color="primary"
        style={{ margin: '20px 20px', width: '80%' }}
        onClick={() => {
          window.location.href = '/';
        }}
      >
        Go back to home page
      </Button>
      <br />
      <a style={{ margin: '20px 20px', width: '80%' }} href={url}>
        Click to download error report document
      </a>
    </>
  );
};
